// Components
import { Loading } from "components/feedbacks"

export const ActionButton = ({
	color = "primary",
	size = "",
	className= "",
	block = false,
	children,
	disabled = false,
	loading,
	outline,
	...rest
}) => {
	// Variables
	const colorProp = {
    primary: "btn-primary",
    secondary: "btn-secondary",
    accent: "btn-accent",
    neutral: "btn-neutral",
    info: "btn-info",
    success: "btn-success",
    warning: "btn-warning",
    error: "btn-error",
    ghost: "btn-ghost",
    link: "btn-link"
  }
	const sizeProp = {
    xs: "btn-xs",
    sm: "btn-sm",
    lg: "btn-lg"
  }

	return (
		<button {...rest} className={`btn ${outline && "btn-outline"} ${color && colorProp[color]} ${size && sizeProp[size]} ${block && "w-full"} ${className}`} disabled={disabled || loading}>
			{loading && <Loading />}
			{children ?? "Submit"}
		</button>
	)
}